module.exports = __webpack_public_path__ + "static/media/evaluacion.22fb8c57.png";